import DownloadIcon from '@mui/icons-material/Download';
import React, { useState } from 'react';
import {
  Box, Button, TextField, Select, MenuItem,
  FormControl, InputLabel, Chip, Typography
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';

const DEPARTMENTS = [
  'HR&A', 'Resource Mobilization and Grant Management',
  'Social Mobilization and Outreach', 'EQAS', 'EVT',
  'OOSC', 'PRS', 'FA', 'IA', 'PROTOCOL',
  'SERVICOM', 'PROCUREMENT', 'LEGAL', 'AE',
];

const QUICK_FILTERS = [
  { label: 'Today', value: 'today' },
  { label: 'This week', value: 'week' },
  { label: 'This month', value: 'month' },
  { label: 'Custom', value: 'custom' },
];

function getDateRange(quickFilter) {
  const today = new Date();
  const fmt = (d) => d.toISOString().split('T')[0];
  if (quickFilter === 'today') return { from: fmt(today), to: fmt(today) };
  if (quickFilter === 'week') {
    const start = new Date(today);
    start.setDate(today.getDate() - today.getDay() + 1);
    return { from: fmt(start), to: fmt(today) };
  }
  if (quickFilter === 'month') {
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    return { from: fmt(start), to: fmt(today) };
  }
  return { from: '', to: '' };
}

export default function AttendanceFilter({
  onFilter,
  onExport,
  showAdminFilters = false,
  users = []
}) {
  const [quickFilter, setQuickFilter] = useState('');
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterDept, setFilterDept] = useState('');
  const [filterUser, setFilterUser] = useState('');
  const [activeFilters, setActiveFilters] = useState([]);

  const handleQuickFilter = (value) => {
    setQuickFilter(value);
    if (value !== 'custom') {
      const range = getDateRange(value);
      setCustomFrom(range.from);
      setCustomTo(range.to);
    }
  };

  const handleApply = () => {
    const params = {};
    const applied = [];
    if (customFrom) { params.from = customFrom; applied.push(`From: ${customFrom}`); }
    if (customTo) { params.to = customTo; applied.push(`To: ${customTo}`); }
    if (filterStatus) { params.status = filterStatus; applied.push(`Status: ${filterStatus}`); }
    if (filterDept) { params.department = filterDept; applied.push(`Dept: ${filterDept}`); }
    if (filterUser) { params.user_id = filterUser; applied.push(`Employee ID: ${filterUser}`); }
    setActiveFilters(applied);
    onFilter(params);
  };

  const handleClear = () => {
    setQuickFilter('');
    setCustomFrom('');
    setCustomTo('');
    setFilterStatus('');
    setFilterDept('');
    setFilterUser('');
    setActiveFilters([]);
    onFilter({});
  };

  return (
    <Box sx={{ p: 2, borderBottom: '0.5px solid #e8ede8', background: '#fafcfa' }}>

      {/* Quick filter pills */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, flexWrap: 'wrap' }}>
        <Typography sx={{ fontSize: 12, color: '#888', mr: 0.5 }}>Quick:</Typography>
        {QUICK_FILTERS.map((f) => (
          <Chip
            key={f.value}
            label={f.label}
            size="small"
            onClick={() => handleQuickFilter(f.value)}
            sx={{
              cursor: 'pointer',
              fontSize: 12,
              background: quickFilter === f.value ? '#1a4d2e' : '#eaf3de',
              color: quickFilter === f.value ? 'white' : '#27500a',
              '&:hover': {
                background: quickFilter === f.value ? '#2d7a4f' : '#d0e8c0',
              },
            }}
          />
        ))}
        {/* Export buttons */}
{onExport && (
  <Box sx={{
    display: 'flex', gap: 1, mt: 2,
    pt: 2, borderTop: '0.5px solid #e8ede8',
    flexWrap: 'wrap', alignItems: 'center'
  }}>
    <Typography sx={{ fontSize: 12, color: '#888', mr: 0.5 }}>Export:</Typography>
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon sx={{ fontSize: 14 }} />}
      onClick={() => onExport('csv', false)}
      sx={{
        fontSize: 12, borderColor: '#2d7a4f',
        color: '#1a4d2e', borderRadius: 2,
        '&:hover': { background: '#f0f8f0' }
      }}
    >
      Filtered CSV
    </Button>
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon sx={{ fontSize: 14 }} />}
      onClick={() => onExport('excel', false)}
      sx={{
        fontSize: 12, borderColor: '#2d7a4f',
        color: '#1a4d2e', borderRadius: 2,
        '&:hover': { background: '#f0f8f0' }
      }}
    >
      Filtered Excel
    </Button>
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon sx={{ fontSize: 14 }} />}
      onClick={() => onExport('csv', true)}
      sx={{
        fontSize: 12, borderColor: '#888',
        color: '#888', borderRadius: 2,
        '&:hover': { background: '#f5f5f5' }
      }}
    >
      All records CSV
    </Button>
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon sx={{ fontSize: 14 }} />}
      onClick={() => onExport('excel', true)}
      sx={{
        fontSize: 12, borderColor: '#888',
        color: '#888', borderRadius: 2,
        '&:hover': { background: '#f5f5f5' }
      }}
    >
      All records Excel
    </Button>
  </Box>
    )}
      </Box>

      {/* Filter row */}
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <TextField
          label="From date"
          type="date"
          size="small"
          value={customFrom}
          onChange={(e) => { setCustomFrom(e.target.value); setQuickFilter('custom'); }}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 150 }}
        />
        <TextField
          label="To date"
          type="date"
          size="small"
          value={customTo}
          onChange={(e) => { setCustomTo(e.target.value); setQuickFilter('custom'); }}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 150 }}
        />

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Status</InputLabel>
          <Select
            label="Status"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
          </Select>
        </FormControl>

        {showAdminFilters && (
          <>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel>Department</InputLabel>
              <Select
                label="Department"
                value={filterDept}
                onChange={(e) => setFilterDept(e.target.value)}
              >
                <MenuItem value="">All departments</MenuItem>
                {DEPARTMENTS.map((d) => (
                  <MenuItem key={d} value={d}>{d}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Employee</InputLabel>
              <Select
                label="Employee"
                value={filterUser}
                onChange={(e) => setFilterUser(e.target.value)}
              >
                <MenuItem value="">All employees</MenuItem>
                {users.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.first_name} {u.last_name} (@{u.username})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        )}

        <Button
          variant="contained"
          size="small"
          startIcon={<FilterListIcon />}
          onClick={handleApply}
          sx={{
            background: '#1a4d2e',
            '&:hover': { background: '#2d7a4f' },
            borderRadius: 2,
            px: 2,
            height: 40,
          }}
        >
          Apply
        </Button>

        {activeFilters.length > 0 && (
          <Button
            size="small"
            startIcon={<CloseIcon />}
            onClick={handleClear}
            sx={{ color: '#888', borderRadius: 2, height: 40 }}
          >
            Clear
          </Button>
        )}
      </Box>

      {/* Active filter tags */}
      {activeFilters.length > 0 && (
        <Box sx={{ display: 'flex', gap: 1, mt: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 11, color: '#888' }}>Active filters:</Typography>
          {activeFilters.map((f) => (
            <Chip
              key={f}
              label={f}
              size="small"
              sx={{ fontSize: 11, background: '#e6f1fb', color: '#0c447c' }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}